export const standardizeTime = (timeStr: string): string => {
    // Handle null/undefined
    if (!timeStr) {
        return timeStr
    }

    // Convert to string and trim whitespace
    const trimmed = String(timeStr).trim()

    // If already in HH:MM format, return as is
    if (/^\d{1,2}:\d{2}$/.test(trimmed)) {
        return trimmed
    }

    // Check if it's a 3 or 4 digit number (potentially a time)
    if (/^\d{3,4}$/.test(trimmed)) {
        // 3 digits: treat as H:MM (e.g., "805" -> "8:05")
        if (trimmed.length === 3) {
            const hours = trimmed.charAt(0)
            const minutes = trimmed.substring(1)
            return `${hours.padStart(2, '0')}:${minutes}`
        }
        // 4 digits: treat as HH:MM (e.g., "1055" -> "10:55")
        else if (trimmed.length === 4) {
            const hours = trimmed.substring(0, 2)
            const minutes = trimmed.substring(2)
            return `${hours}:${minutes}`
        }
    }

    // If it doesn't match time patterns, return original string
    return timeStr
}
